export const toLocaleTimeString = (timeStamp) => {
  const date = new Date(`${timeStamp || ''}${(timeStamp || '').includes('Z') ? '' : 'Z'}`);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = String(date.getFullYear()).substring(2);
  const time = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${mm}.${dd}.${yyyy} ${time}:${minute}:${seconds}`;
};
